/**
 * If `condition` is true it throws error with `msg` in dev and `console.error`s `msg` otherwise
 * @param condition
 * @param msg
 */
export default function throwErrorInDev(condition, msg, info = 'n/a') {
    if (process.env.NODE_ENV !== 'production') {
        if (!condition) {
            return;
        }
        console.error(msg, 'Info:', info);
        throw new Error(msg);
    }
}
//# sourceMappingURL=throwErrorInDev.js.map